import { WorkplaceFlowDto } from "@/store/workplaces-flow/dtos/input/WorkplaceFlow.dto";
import { WorkplaceFlowForm } from "@/store/workplaces-flow/interfaces/WorkplaceFlowForm.interface";

export function FlowDtoToFlowForm(
  workplaceFlow: WorkplaceFlowDto
): WorkplaceFlowForm {
  const { customFields } = workplaceFlow;
  return { workplaceFlow: { customFields } };
}
